import type { FC } from 'react';
import { Button, Flex, Typography } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

export interface PortfolioPageHeaderProps {
  title: string;
  scopeLabel: string;
  generateReportLabel: string;
  onGenerateReport: () => void;
}

export const PortfolioPageHeader: FC<PortfolioPageHeaderProps> = ({
  title,
  scopeLabel,
  generateReportLabel,
  onGenerateReport,
}) => {
  return (
    <Flex
      justify="space-between"
      align="flex-start"
      gap={16}
      wrap="wrap"
      className="om-dashboard-header"
    >
      <div>
        <Title level={3} className="ds-page-title" style={{ margin: 0 }}>
          {title}
        </Title>
        <Text type="secondary" className="om-dashboard-header__subtitle">
          {scopeLabel}
        </Text>
      </div>
      <Button
        type="default"
        icon={<FileTextOutlined />}
        onClick={onGenerateReport}
      >
        {generateReportLabel}
      </Button>
    </Flex>
  );
};
